// extracted by mini-css-extract-plugin
module.exports = {"container":"Items_container__Pq0Cw","header":"Items_header__9ZeKw","headerText":"Items_headerText__2F65_"};